import React, { Fragment, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { WebHookSubscriptionWithDetailInitialsForAdd, WebHookSubscriptionWithDetailInitialsForUpdate } from "./interfaces/WebHookClass";
import { addAccountWebHookSubscriptionAsync, updateAccountWebHookSubscriptionAsync, checkedState, unCheckedState, checkedStateById, resetSelectedRecordObjectInState } from "./WebHookSlice";
import Select, { StylesConfig } from 'react-select';
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import { getValueFromResource } from "../../../common/timeLiveFunction";


export const WebHookForm = (props: any) => {

    const { t, oncloseModal } = props;
    const { selectedRecord, WebHookSubscriptionWithDetailObject, isLoading, SystemWebHookEventTypesList } = useAppSelector((state) => state.webHook);
    const [currentFieldsData, SetcurrentFieldsData] = useState<any>(WebHookSubscriptionWithDetailInitialsForAdd);

    const [WebHookEntries, setWebHookEntries] = useState<any>({ SystemWebHookEventTypeId: '', WebHookEventName: '', Stat: false });
    const dispatch = useAppDispatch();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const defaultFocusRef = useRef<HTMLInputElement>(null);

    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(WebHookSubscriptionWithDetailInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            
            
            dispatch(checkedState(stateItem.WebHookEntries));
            SetcurrentFieldsData(stateItem);
        }
        
        else {
            SetcurrentFieldsData(WebHookSubscriptionWithDetailInitialsForAdd);
        }
        
    }, [selectedRecord])

    if (defaultFocusRef.current) {
        defaultFocusRef.current.focus();
    }
  
    const handleTextChange = (e: any) => {
        SetcurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const [loading, setLoading] = useState(false);
    const isGuid = (stringToTest: any) => {
        if (stringToTest[0] === "{") {
            stringToTest = stringToTest.substring(1, stringToTest.length - 1);
        }
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        var x = regexGuid.test(stringToTest);
        return x;
    };
    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {

            const concatenatedArray = values.WebHookEntries.concat(WebHookSubscriptionWithDetailObject.WebHookEntries);
            const uniqueRecords: any = [];
            const uniqueIds = new Set();

            concatenatedArray.forEach((record: any) => {
                if (!uniqueIds.has(record.SystemWebHookEventTypeId)) {
                    uniqueIds.add(record.SystemWebHookEventTypeId);
                    uniqueRecords.push(record);
                }
            });
            values.WebHookEntries = uniqueRecords;
            dispatch(updateAccountWebHookSubscriptionAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    if (originalPromiseResult.Result !== null) {
                        isGuid(originalPromiseResult.Result.id) ?
                            ShowToast("WebHook Update Successfully", 'Success', "success", "toast-top-right") :
                            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    }
                    else {
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    }
                }).catch((rejectedValueOrSerializedError) => {
                })
        }
        else {
            dispatch(addAccountWebHookSubscriptionAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    if (originalPromiseResult.Result !== null) {
                        isGuid(originalPromiseResult.Result.id) ?
                            ShowToast("WebHook Add Successfully", 'Success', "success", "toast-top-right") :
                            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    }
                    else {
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    }
                }).catch((rejectedValueOrSerializedError) => {
                })
        }
        oncloseModal();
    }

    const CheckBoxChangeHandle = (e: any, values: any, setFieldValue: any) => {
        const { checked, id } = e.target;
        const name = e.target.getAttribute('data-name');

        const updatedWebhookEntries = checked
            ? [
                ...values.WebHookEntries,
                { SystemWebHookEventTypeId: id, WebHookEventName: name, Stat: true },
            ]
            : values.WebHookEntries.filter((item: any) => item.SystemWebHookEventTypeId !== id);

        checked
            ? dispatch(checkedState(updatedWebhookEntries))
            : dispatch(unCheckedState(id))


        setFieldValue('WebHookEntries', updatedWebhookEntries);
    };

    return (
        <>
            <Formik
                initialValues={currentFieldsData} 
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    WebHookName: yup
                        .string()
                        .label
                        // ('WebHookName')
                        (getValueFromResource('WebHookName',dispatch, t))
                        .trim()
                        .required
                        // (t('WebHook Name is required')),
                        (getValueFromResource('WebHook Name is required',dispatch, t)),
                    TargetURL: yup.string()
                        .url
                        // (t('Invalid URL format'))
                        (getValueFromResource('Invalid URL format',dispatch, t))
                        .required
                        // (t('TargetURL is required')),
                        (getValueFromResource('TargetURL is required',dispatch, t)),

                    WebHookEntries: yup
                        .array()
                        .of(
                            yup.object().shape({
                                Stat: yup.boolean(),
                            })
                        )
                        .test('at-least-one-checked', 'At least one event must be checked', function (value) {
                            const atLeastOneChecked = value && value.some(item => item.Stat);
                            return atLeastOneChecked;
                        })
                })}>
                {({ values, handleChange, setFieldValue, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSubmit();
                            }
                        }}>
                            {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <>
                                    <div className="modal drawer-overlay" style={{ display: 'block' }}>
                                        <div className="modal-dialog modal-dialog-scrollable modal-lg">
                                            <div className="modal-content">
                                                <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                    <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ?
                                                    //  t('Update WebHook') 
                                                    getValueFromResource('Update WebHook',dispatch, t) :
                                                    //   t('Add WebHook')} 
                                                    getValueFromResource('Add WebHook',dispatch, t)}
                                                      </h5>
                                                    <div
                                                        className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                        onClick={oncloseModal}
                                                    >
                                                        <KTSVG
                                                            path="/media/icons/duotune/arrows/arr061.svg"
                                                            className="svg-icon svg-icon-1x"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="modal-body">

                                                    <div className='row'>
                                                        <div className="col-md-6 mb-2">
                                                        <label className="form-label fs-7 fw-normal">
                                                            {/* {t('WebHook Name')} */}
                                                            {getValueFromResource('WebHook Name',dispatch, t)}
                                                            </label>
                                                            <input type="text"
                                                                className="form-control fs-7 fw-normal"
                                                                id='WebHookName'
                                                                name="WebHookName"
                                                                value={values.WebHookName}
                                                                onChange={handleChange('WebHookName')}
                                                                // ref={defaultFocusRef}
                                                                ref={values.WebHookName?.trim() === '' ? defaultFocusRef : null}
                                                                onBlur={() => setFieldTouched('WebHookName')}
                                                            />
                                                            <div >
                                                                {touched.WebHookName && errors.WebHookName &&
                                                                    <p className='errorMsg'>{errors.WebHookName as string}</p>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 mb-2">
                                                            <label className=" form-label fs-7 fw-normal">
                                                                {/* {t('Target URL')} */}
                                                                {getValueFromResource('Target URL',dispatch, t)}
                                                                </label>
                                                            <input type="text"
                                                                className="form-control fs-7 fw-normal"
                                                                id='TargetURL'
                                                                name="TargetURL"
                                                                value={values.TargetURL}
                                                                onChange={handleChange('TargetURL')}
                                                                onBlur={() => setFieldTouched('TargetURL')}
                                                                placeholder="Enter URL with http://"
                                                            />
                                                            <div >
                                                                {touched.TargetURL && errors.TargetURL &&
                                                                    <p className='errorMsg'>{errors.TargetURL as string}</p>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div>
                                                        <h5 className="modal-title">
                                                            {/* {t('Events')} */}
                                                            {getValueFromResource('Events',dispatch, t)}
                                                            </h5>
                                                            <hr className="mt-2 mb-2" />
                                                            <div className="row">
                                                                <div >
                                                                    {touched.WebHookEntries && errors.WebHookEntries && (
                                                                        <p className='errorMsg'>{errors.WebHookEntries as any}</p>
                                                                    )}
                                                                </div>
                                                                {SystemWebHookEventTypesList.map((group, groupIndex) => (
                                                                    <div className="col-lg-6 mb-3" key={groupIndex}>
                                                                        <label className="form-label" style={{ fontWeight: 'bold' }}>{group.GroupName}</label>
                                                                        <table style={{ border: '0' }} className="table  table-hover borderless">
                                                                            <tbody>
                                                                                {group.Items.map((item, itemIndex) =>
                                                                                (

                                                                                    <tr key={itemIndex}>
                                                                                        <td style={{ verticalAlign: 'middle' }}>

                                                                                            <span style={{ float: 'left', marginLeft: '25px' }} className="fs-7 fw-normal">{item.SystemWebhookEventTypeCaption}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span className="m-switch m-switch--sm m-switch--icon" style={{ float: 'right', fontSize: '14px', fontWeight: '500', marginRight: '10px', height: '24px' }}>
                                                                                                <label style={{ marginBottom: '-10px' }}>
                                                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-1">
                                                                                                        <input className="form-check-input custom-padding-right mb-2 h-15px w-30px" type="checkbox"
                                                                                                            data-id={item.SystemWebHookEventTypeID}
                                                                                                            data-name={item.SystemWebHookEventName}
                                                                                                            checked={item.Checked || false}

                                                                                                            id={item.SystemWebHookEventTypeID}
                                                                                                            name={item.SystemWebHookEventTypeID}
                                                                                                            onChange={(e: any) =>
                                                                                                                CheckBoxChangeHandle(e, values, setFieldValue)
                                                                                                            }

                                                                                                        />
                                                                                                    </div>

                                                                                                    <span></span>
                                                                                                </label>
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        {Object.keys(selectedRecord).length > 0 ? (
                                                            <div className="col-md-6">
                                                                <label className="fs-7 fw-normal">
                                                                    {/* {t('Disabled')} */}
                                                                    {getValueFromResource('Disabled',dispatch, t)}
                                                                    </label>
                                                                {/* <label className="form-label">IsActive</label> */}
                                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                    <input className="form-check-input h-20px w-30px"
                                                                        type="checkbox"
                                                                        checked={values.IsActive}
                                                                        id="IsActive"
                                                                        name="IsActive"
                                                                        onChange={handleChange('IsActive')}
                                                                    />
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                        onClick={oncloseModal}
                                                    >
                                                        {/* {t('Cancel')} */}
                                                        {getValueFromResource('Cancel',dispatch, t)}

                                                    </button>
                                                    <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                    {/* {t('Save')}   */}
                                                    {getValueFromResource('Save',dispatch, t)}

                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </form>
                    </Fragment>
                )}
            </Formik >
        </>
    )

}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}


